import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

export default function ContactPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
        <h1 className="twentytwentysix-content__title">Contact Us</h1>
        <p className="twentytwentysix-content__copy">
          Have a question, partnership idea, or want to get in touch? We&apos;d love to hear from you.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix" className="twentytwentysix-content__pill">Back to Home</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <h2 className="twentytwentysix-content__subtitle">Get in touch</h2>
          <p className="twentytwentysix-content__copy">
            For general inquiries, membership questions, or media: reach out through the main site contact form or email. We serve the Bay Area, Sacramento Valley, and LA County.
          </p>
          <p className="twentytwentysix-content__copy">
            For M List applications or business partnerships, include your business name and how you&apos;d like to be involved.
          </p>
        </section>
      </div>
    </div>
  );
}
